export const en = {
  Authentication: {
    Profile: {
      Login: 'Login',
      Logout: 'Logout',
      ViewAccount: 'View account',
    },
  },
};
